import { tocaSSOLogin } from 'toca-sso'

const baseURL = process.env.VUE_APP_BASE_URL;
export async function goLogin(sso_callback_url, agentId, isLogout = false) {
    return await tocaSSOLogin({
        redirectUrl: sso_callback_url,
        agentId,
        BASE_URL: process.env.VUE_APP_BASE_URL,
        autoLogin: !isLogout,
        isLogout
    });
}
